import React, { ReactNode } from "react";
import styled from "styled-components";
import { TextAlign, TextColor } from "./helper";

const headingVariants = ["h1", "h2", "h3", "h4", "h5", "h6"] as const;

const fontWeights = ["light", "regular", "semiBold", "bold"] as const;

export type HeadingVariant = typeof headingVariants[number];

export type FontWeights = typeof fontWeights[number];

interface HeadingProps {
  variant?: HeadingVariant;
  color?: TextColor;
  align?: TextAlign;
}

interface Props extends HeadingProps {
  children: ReactNode;
  id?: string;
  className?: string;
  fontWeight?: FontWeights;
}

const Heading: React.FC<Props> = ({
  color = "primary",
  variant = "h1",
  align = "left",
  children,
  id,
  className,
  fontWeight,
}) => (
  <StyledHeading
    as={variant}
    variant={variant}
    color={color}
    align={align}
    id={id}
    className={className}
    fontWeight={fontWeight}
  >
    {children}
  </StyledHeading>
);

export default Heading;

const StyledHeading = styled.h6<Required<HeadingProps> & { fontWeight?: FontWeights }>`
  white-space: pre-line;
  font-family: ${({ theme, variant }) => theme.typography.heading[variant].fontFamily};
  font-weight: ${({ theme, variant, fontWeight }) =>
    fontWeight ?? theme.typography.heading[variant].fontWeight};
  font-size: ${({ theme, variant }) => theme.typography.heading[variant].fontSize}px;
  color: ${({ theme, color }) => theme.colors.text[color]};
  text-align: ${({ align }) => align};
`;
